import { FC } from "react";

import Stack from "@mui/material/Stack";

import { DashboardIconButton } from "@/dashboard-design-system/DashboardButton";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";
import { ChevronLeft, ChevronRight } from "@/icons/outlined";

interface MonthNavigatorProps {
  monthLabel: string;
  onPrevious: () => void;
  onNext: () => void;
}

export const MonthNavigator: FC<MonthNavigatorProps> = ({ monthLabel, onPrevious, onNext }) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" pt={2} pb={1} pl={3} pr={1.5}>
    <DashboardIconButton vibe="neutral" size="small" onClick={onPrevious} data-test="edit-charge-date-previous-month">
      <ChevronLeft />
    </DashboardIconButton>
    <DashboardTypography variant="subtitle1" vibe="text-neutral-moderate" sx={{ textTransform: "capitalize" }}>
      {monthLabel}
    </DashboardTypography>
    <DashboardIconButton vibe="neutral" size="small" onClick={onNext} data-test="edit-charge-date-next-month">
      <ChevronRight />
    </DashboardIconButton>
  </Stack>
);
